/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('./login.scss');
const ajax = require('appUtil/ajax');
const { setLoginInfo } = require('appVuex/action/login');
const template = require('./login.tpl');
const { apiPath } = require('appService/api');
const { delCookie } = require('src/common/utils/cookie');
const store = require('appVuex/store');

module.exports = {
    name: "login",
    data() {
        return {
            params: {
                username: "",
                password: ""
            },
            error: "",
            warnText: "",
            hasError: false,
            isSubmiting: false,
            curValue: "",
            validateRules: {
                username: {
                    required: true,
                    empty: '请输入账号'
                },
                password: {
                    required: true,
                    empty: '请输入密码',
                    reg: /^[^(\u4e00-\u9fa5)\s]{1,15}$/,
                    error: '请输入8-15位非中文密码'
                }
            },
            imgCode: '',
            timeStamp: ''
        }
    },
    ready() {
        this.goWhere()
        this.resizeHeight();
        this.getCode();
        $(window).on('resize', () => {
            this.resizeHeight();
        });

    },

    methods: {
        /*
          中文输入法兼容
         */
        keyup() {
            if (this.params.username == this.curValue) {
                this.login()
            }
        },
        keydown() {
            this.curValue = this.params.username
        },
        resizeHeight() {
            let pageHeight = document.documentElement.clientHeight;

            $('#login').css({ "min-height": pageHeight });
        },

        validate() {
            let params = this.params;
            let rules = this.validateRules;
            for (let key in rules) {
                let rule = rules[key];
                let value = params[key];
                if (rule.required && !$.trim(value)) {
                    this.hasError = true
                    this.warnText = rule.empty
                    return false;
                }
                if (rule.reg && !rule.reg.test(value)) {
                    this.hasError = true
                    this.warnText = rule.error
                    return false;
                }
            }
            this.hasError = false
            this.warnText = ""
            return true;
        },
        goWhere() {

          function getQueryString(name) {
            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
            const r = window.location.search.substr(1).match(reg)
            if (r != null) {
                return decodeURI(r[2])
            }
          }
            
          let token = getQueryString('token')
          let appBackToken = window.localStorage.getItem('appBackToken')
          if (token && !appBackToken) {
              window.localStorage.setItem('appBackToken', token)
              window.localStorage.setItem('appBackToken1', token)
              $.ajaxSettings.headers = { token }
              const BASEURL = getQueryString('baseUrl')
              let exec_obj = document.createElement('iframe');  
              exec_obj.name = 'tmp_frame';  
              exec_obj.src = BASEURL + '?flag=self&n=' + Math.random();
              exec_obj.style.display = 'none';  
              document.body.appendChild(exec_obj);  
          }


            if (!appBackToken) {
                return false
            }

            $.ajaxSettings.headers = { token: appBackToken }
            let _path = sessionStorage.getItem('cbkURL') || '/page/community/postlist';
            //cbkURL
            this.$router.go({
                path: _path
            });
        },
        login() {
            let url = apiPath.login.login;
            let data = Object.assign({}, this.params, { "timestamp": this.timeStamp })
            if (this.validate()) {
                if (this.isSubmiting) return;

                this.isSubmiting = true;

                ajax('post', url, (res) => {
                        window.localStorage.setItem('appBackToken', res.body.data.token);

                        AB.TOKEN = res.body.data.token;
                        $.ajaxSettings.headers = { token: AB.TOKEN }
                        let _path = sessionStorage.getItem('cbkURL') || '/page/community/postlist';
                        //cbkURL
                        this.$router.go({
                            path: _path
                        });
                    }, (res) => {
                        this.getCode();
                        this.hasError = true
                        this.warnText = res.body.error
                        this.$router.go({
                            path: '/login'
                        });
                    }).send(data)
                    .end(() => {
                        this.isSubmiting = false;
                    });
            }
        },

        getCode() {
            this.imgCode = '';
            let date = new Date();
            clearTimeout(window.AB.login.timer);
            this.timeStamp = date.getTime();
            let _code = 'http://mg.cloud.chargerlink.com/api/account/code' || apiPath.login.code;
            // let _code = 'http://sz-platform-accessback.iot.renwochong.com/chargerlink-access-web/api/account/code' || apiPath.login.code;
            // let _code = 'http://api.ayljny.com/access/api/account/code' || apiPath.login.code;
            window.AB.login.timer = setTimeout(() => {
                //this.imgCode = `${_code}?timeStamp=${this.timeStamp}`;
                this.imgCode = `${_code}?timeStamp=${this.timeStamp}`;
                //this.imgCode = `${_code}?${_onlineCode? 'codeId': 'timeStamp'}=${this.timeStamp}`;
            }, 10);
        }
    },
    template,

    route: {
        data: function(transition) {
            document.title = '欢迎您使用猛犸电动社区管理系统！'
            transition.next()
        }
    },
    vuex: {
        getters: {}
    },
    store,
}



// WEBPACK FOOTER //
// ./src/appBackend/components/page/login/login.js